/**
 * Normalizes a theme-authored aspect ratio into a value the CSS `aspect-ratio`
 * property actually understands ("16 / 9"). Theme JSON has repeatedly shipped
 * colon notation ("16:7", "4:3") copied from design-brief shorthand — CSS silently
 * ignores an invalid aspect-ratio declaration rather than erroring, so blocks that
 * also set height:auto whenever aspectRatio is "set" collapse to a 0px-tall,
 * invisible container even though the image inside loaded fine (confirmed live:
 * wieszak_v4/glogowskiwieszak.pl, 2026-07-31 — hero slider had "16:7").
 */
export function toCssAspectRatio(value: string | null | undefined): string {
    if (!value || value === 'auto') return 'auto';
    const normalized = value.includes(':') ? value.replace(':', '/') : value;
    return /^\d+(\.\d+)?\s*\/\s*\d+(\.\d+)?$/.test(normalized) ? normalized : 'auto';
}
